<template>
  <div class="productIntroduction">
    <div class="head">
      <span>{{title}}</span>
      <p>
        <span v-for="(item, i) in proList" :key="i" :class="{active: showType==i}" @click="changeType(i)">{{item}}</span>
      </p>
    </div>
    <pro-info ref="proInfo"></pro-info>
  </div>
</template>

<script>
import proInfo from '../components/proInfo'
export default {
  name: 'productIntroduction',
  data () {
    return {
      title: '产品介绍',
      proList: ['业主版', '彩友版'],
      showType: 0
    }
  },
  components: {proInfo},
  mounted () {
    this.$refs.proInfo.hideUserWord()
  },
  methods: {
    changeType (index) {
      this.showType = index
      this.$refs.proInfo.changeShowType(index)
    }
  }
}
</script>

<style scoped lang="less">
  .productIntroduction{
    >.head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      padding: 25px 0;
      box-sizing: border-box;
      color: #5E5E5E;
      span{
        margin: 0 25px;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
      }
      >span{
        padding-right: 20px;
        border-right: 1px solid #5E5E5E;
      }
      >p{
        cursor: pointer;
        color: #BBBBBB;
        float: right;
        >.active{
          color: #5E5E5E;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/productIntroduction.vue